import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import cj from '@/components/cj'
import ks from '@/components/ks'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/cj',
      name: 'cj',
      component: cj
    },
    {
      path: '/ks',
      name: 'ks',
      component: ks
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})
